export default __webpack_public_path__ + "media/components/AdEdit/images/fb-promo-logo-137ef93b9b93ec05a09b6eb28c0c5137.png";